/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterEditTermRequest,
  PresenterError,
  PresenterGenerateTermRequest,
  PresenterOneShortTermResponse,
  PresenterOneTermMonthResponse,
  PresenterOneTermPagingResponse,
  PresenterOneTermResponse,
  PresenterResponse,
  PresenterTermMonthFilter,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AccountingPeriods<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description ListFullTerms accounting periods
   *
   * @tags accounting_periods
   * @name GetAccountingPeriodsFullTerms
   * @summary ListFullTerms the accounting periods
   * @request GET:/accounting_periods/full_terms
   */
  getAccountingPeriodsFullTerms = (
    query?: {
      "filter[end_date]"?: string;
      "filter[period]"?: number;
      "filter[start_date]"?: string;
      "filter[year]"?: number;
      sort?: string[];
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/full_terms`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate terms
   *
   * @tags accounting_periods
   * @name PostAccountingPeriodsGenerateTerms
   * @summary Generate the terms
   * @request POST:/accounting_periods/generate_terms
   */
  postAccountingPeriodsGenerateTerms = (
    body: PresenterGenerateTermRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/generate_terms`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get paging info with term_month info accounting period with id
   *
   * @tags accounting_periods
   * @name GetAccountingPeriodsPagingByTerm
   * @summary Get the paging info accounting period by ID
   * @request GET:/accounting_periods/paging_by_term
   */
  getAccountingPeriodsPagingByTerm = (
    query: {
      cycle_type: number;
      term_id: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermPagingResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/paging_by_term`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description GetTermMonthByDate accounting periods
   *
   * @tags accounting_periods
   * @name PostAccountingPeriodsTermMonthByDate
   * @summary GetTermMonthByDate the accounting periods
   * @request POST:/accounting_periods/term_month_by_date
   */
  postAccountingPeriodsTermMonthByDate = (
    body: PresenterTermMonthFilter,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermMonthResponse;
      },
      PresenterError
    >({
      path: `/accounting_periods/term_month_by_date`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description ListTermMonths accounting periods
   *
   * @tags accounting_periods
   * @name GetAccountingPeriodsTermMonths
   * @summary ListTermMonths the accounting periods
   * @request GET:/accounting_periods/term_months
   */
  getAccountingPeriodsTermMonths = (
    query?: {
      "filter[end_date]"?: string;
      "filter[start_date]"?: string;
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermMonthResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/term_months`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description ListTerms accounting periods
   *
   * @tags accounting_periods
   * @name GetAccountingPeriodsTerms
   * @summary ListTerms the accounting periods
   * @request GET:/accounting_periods/terms
   */
  getAccountingPeriodsTerms = (
    query?: {
      "filter[end_date]"?: string;
      "filter[period]"?: number;
      "filter[start_date]"?: string;
      "filter[year]"?: number;
      sort?: string[];
      "page[number]"?: number;
      "page[size]"?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneShortTermResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/terms`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update and reenerate terms
   *
   * @tags accounting_periods
   * @name PutAccountingPeriodsTerms
   * @summary Update and regenerate the terms
   * @request PUT:/accounting_periods/terms
   */
  putAccountingPeriodsTerms = (
    body: PresenterEditTermRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/terms`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate and store terms to the database
   *
   * @tags accounting_periods
   * @name PostAccountingPeriodsTerms
   * @summary Generate and store the terms
   * @request POST:/accounting_periods/terms
   */
  postAccountingPeriodsTerms = (
    body: PresenterGenerateTermRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermResponse[];
      },
      PresenterError
    >({
      path: `/accounting_periods/terms`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get accounting period with id
   *
   * @tags accounting_periods
   * @name GetAccountingPeriodsTermsById
   * @summary Get the accounting period by ID
   * @request GET:/accounting_periods/terms/{id}
   */
  getAccountingPeriodsTermsById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneTermResponse;
      },
      PresenterError
    >({
      path: `/accounting_periods/terms/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
